const state = {
  activeInputs: {},
  inactiveInputs: {},
  inputTypes: [],
  inputs: []
};
const getters = {
  getActiveInputs(state) {
    return state.activeInputs;
  },
  getInactiveInputs(state) {
    return state.inactiveInputs;
  },
  getDiscreteInputTypes(state) {
    return state.inputTypes
  },
  allInputsGetter: state => state.inputs
};
const actions = {
};
const mutations = {
  setActiveInputs(state, obj) {
    state.activeInputs = {};
    state.inactiveInputs = {};
    for (let num of obj.enabled) state.activeInputs[num] = true;
    for (let num of obj.disabled) state.inactiveInputs[num] = true;
  },
  setInputActivity(state, { num, active }) {
    if (active) {
      state.activeInputs[num] = true;
      delete state.inactiveInputs[num];
    } else {
      state.inactiveInputs[num] = true;
      delete state.activeInputs[num];
    }
  },
  setInputTypes(state, arr) {
    state.inputTypes = arr
  },
  setInputs(state, arr) {
    state.inputs = arr
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};